<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>

    <button type="button" class="close" aria-label="Close" (click)="activeModal.close(null)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-pdf-viewer [file]="file" [blobFile]="blobFile" [selectedCertificate]="selectedCertificate" (signed)="sign($event)" [refreshDocument]="refreshDocumentSubject.asObservable()" ></app-pdf-viewer>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" *ngIf="showOnlySaveButton" (click)="persistPdf(false)" translate [disabled]="!signedFile">Save signed pdf</button>
    <button class="btn btn-primary" *ngIf="showSaveAndSendButton" (click)="persistPdf(true)" translate [disabled]="!signedFile">
        Save & send signed pdf
    </button>
    <button class="btn btn-primary" (click)="reloadFile()" translate>Reload</button>
    <button class="btn btn-secondary" (click)="activeModal.close(null)" translate>Cancel</button>
</div>
